import 'shareon/css'

import * as Shareon from 'shareon'

export function initSharing() {
  Shareon.init()
}
